import React from "react"
import { useMsal } from "@azure/msal-react"
import { Navigate } from "react-router"
import { b2cPolicies } from "../../Auth/AuthConfig"
import Loader from "../../Components/Shared/Loader/loader"

const MobilePage = () => {

    const context = useMsal()

    if (context.inProgress !== "none") {
        return <Loader />
    }

    if (context.accounts.length === 0) {
        context.instance.loginRedirect(b2cPolicies.authorities.signUpSignIn)
        return <></>
    }

    return (
        <div className="h-75">
            <img alt="LOGO" className="logo light-logo m-4" src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/codeless-one-logo.svg`} />
            <div className="d-center h-100 d-flex justify-content-center">
                <div className="row text-center">
                    <div className="col-12">
                        <img width={300} src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/MobileView.png`} alt="responsive webite" className="text-center" />
                        <h4 className="mb-4">
                            Please access the platform from your desktop
                        </h4>
                    </div>
                </div>
            </div >
        </div>
    );
}

export default MobilePage